import React from 'react';
import { FileText, Clock } from 'lucide-react';
import { Card } from '../../components/ui/card';
import { serviceHubItems as mockServiceHubItems } from '../../data/mockData';
import OfferingCard from '../../components/OfferingCard';

const SERVICES_HERO_IMG = '/images/hero-slide-1-community.jpeg';

// Card layout here deliberately mirrors LearnHub/VolunteerHub so every thumbnail
// in the app reads as the same object: image, tag, save heart, then three lines.
export default function ServicesHub({ items, savedIds, onToggleSave, onSelectService, onTrackApplication }) {
  const serviceHubItems = items || mockServiceHubItems;
  return (
    <div data-testid="services-hub">
      <div className="p-4 desktop-shell md:pt-6">
        <div
          className="relative rounded-2xl overflow-hidden h-[150px] md:h-[220px]"
          data-testid="services-hero"
          style={{ backgroundColor: '#0F9488' }}
        >
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-[55%] pl-5 md:pl-10 z-10">
              <h2 className="text-2xl md:text-3xl font-extrabold text-white leading-tight">
                We&apos;re Here to Help
              </h2>
              <p className="text-xs md:text-base text-white/80 mt-1.5 md:mt-2.5 leading-snug">
                Aid, care and support for every family — quick, confidential and dignified.
              </p>
            </div>
            <img
              src={SERVICES_HERO_IMG}
              alt=""
              className="absolute right-0 bottom-0 h-full w-[55%] object-cover object-bottom"
            />
          </div>
        </div>
      </div>

      <div className="px-4 pb-2 desktop-shell" data-testid="services-list">
        <h2 className="text-base md:text-lg font-bold text-[#0F172A] mb-3">Our Services</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 pb-1">
          {serviceHubItems.map((item) => (
            <OfferingCard
              key={item.id}
              item={item}
              isSaved={savedIds?.has(item.id)}
              onToggleSave={onToggleSave}
              onClick={() => onSelectService(item.id)}
              testId={`service-card-${item.id}`}
              saveTestId={`service-save-${item.id}`}
            />
          ))}
        </div>
      </div>

      <div className="px-4 pt-3 pb-6 desktop-shell grid grid-cols-2 gap-3 md:max-w-xl">
        <Card
          className="cursor-pointer card-hover"
          data-testid="services-track-application"
          onClick={onTrackApplication}
        >
          <div className="p-4 flex flex-col items-center text-center gap-2">
            <FileText className="h-6 w-6 text-primary" />
            <p className="text-xs font-semibold">Track My Application</p>
          </div>
        </Card>
        {/* Informational only — styled flat so it doesn't read as a link. */}
        <div className="rounded-xl border border-border bg-muted/40 p-4 flex flex-col items-center text-center gap-2">
          <Clock className="h-6 w-6 text-muted-foreground" />
          <p className="text-xs font-semibold text-muted-foreground">48hr Response Time</p>
        </div>
      </div>
    </div>
  );
}
